module.exports = __webpack_public_path__ + "static/z_tall_mormongrit-b277ea52d682dfbf97e8a09f762f58d0.jpg";